<template>
    <div class="mx-5 mb-8">
        <div class="text-center m-4 rounded">
            <div class="mb-6 text-primary h3">
                {{ title }}
            </div>
            <div class="row">
                <div class="h5 col-lg-6 mb-4">
                    {{ __("general.article") }}: {{ computedProductName }}
                </div>
                <div class="h5 col-lg-6">
                    {{ __("general.ean") }}: {{ ean }}
                </div>
                <div class="h5 col-lg-6">
                    {{ __("general.brand") }}: {{ computedBrandName }}
                </div>
                <div v-show="article.attributes.length > 0" class="col-lg-6">
                    <div class="h5">{{ __("general.attributes") }}:</div>
                    <div class="h6" v-for="attribute in article.attributes">
                        {{ attribute.name }} -
                        {{
                            attribute.value
                                ? attribute.value
                                : attribute.pivot.value
                        }}
                    </div>
                </div>
                <div
                    class="mx-auto mt-6"
                    :class="
                        article.attributes.length > 0 ? 'col-lg-6' : 'col-12'
                    "
                >
                    <img
                        :src="articleImage"
                        :alt="__('general.article_image')"
                        class="max-w-100px max-w-md-200px mb-6"
                    />
                </div>
            </div>
        </div>

        <div
            class="text-primary text-center h3"
            v-if="article.stocks && Object.keys(article.stocks).length > 0"
        >
            {{ __("product.check_ean.article_in_stores") }}
        </div>
        <div
            v-for="stock in article.stocks"
            class="card card-body card-custom m-6 border shadow border-primary"
        >
            <div class="h5">{{ stock.label }}</div>
            <div class="row">
                <div class="h6 col-lg-6">
                    {{ __("general.stock") }}: {{ stock.quantity }}
                </div>
                <div class="h6 col-lg-6">
                    {{ __("general.price") }}: {{ stock.price }} €
                </div>
            </div>
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ArticleBox",
    props: {
        article: Object,
        articleFound: Boolean,
        productName: String,
        brandName: String,
        successEan: String,
        success: Boolean,
    },
    computed: {
        computedProductName() {
            return this.articleFound
                ? this.article.product.name
                : this.productName;
        },
        ean() {
            return this.articleFound ? this.article.ean : this.successEan;
        },
        computedBrandName() {
            return this.articleFound
                ? this.article.product.brand.name
                : this.brandName;
        },
        articleImage() {
            return this.articleFound
                ? this.article.images[0].url
                : "svg/success.svg";
        },
        title() {
            return this.articleFound && !this.success
                ? __("product.check_ean.article_found_database")
                : __("product.check_ean.article_created");
        },
    },
};
</script>
